import { Observable, of, throwError } from 'rxjs';
import { delay } from 'rxjs/operators';

/**
 * Default simulated network latency for mock responses. Keeps async semantics
 * consistent with real HTTP so feature code (loading flags, race handling) is
 * exercised even in mock mode.
 */
const DEFAULT_MOCK_LATENCY_MS = 120;

/** Wrap a value in an `Observable<T>` with simulated network latency. */
export function mockResponse<T>(value: T, latencyMs: number = DEFAULT_MOCK_LATENCY_MS): Observable<T> {
  return of(value).pipe(delay(latencyMs));
}

/** Emit an error via `Observable<T>` with simulated network latency. */
export function mockError<T = never>(message: string, latencyMs: number = DEFAULT_MOCK_LATENCY_MS): Observable<T> {
  return throwError(() => new Error(message)).pipe(delay(latencyMs));
}
